import { Link, useNavigate } from "react-router-dom";
import logomain from "../../../images/logo-main.png";
import { useState } from "react";
import { OTPFunction } from "./OTPFunction";
import { useDispatch, useSelector } from "react-redux";
import { LoadPanel, Toast } from "devextreme-react";
import OtpInput from "react-otp-input";

export const OTP = ({ setotpshow }) => {
  const navigation = useNavigate();
  const clas = new OTPFunction();
  const { token } = useSelector((store) => store.login);
  const [otp, setOtp] = useState("");
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [validation, setvalidation] = useState("");
  const [toastConfig, setToastConfig] = useState({
    isVisible: false,
    type: "",
    message: "",
  });

  const OnSubmit = () => {
    if (String(otp)?.length !== 6) {
      setvalidation(clas.ErrorValidationConstant);
      return;
    }
    clas.OTP(
      {
        otp: otp,
        deviceType: 3,
        deviceToken: "abcd",
        deviceId: "abcd",
        // adding these two variables required for otp process. In initiale code these are not added but for api its required.
        screenType: 3,
        type: "forgot-password",
      },
      navigation,
      token,
      setToastConfig,
      toastConfig,
      setvalidation,
      dispatch,
      setLoading
    );
  };

  return (
    <>
      <LoadPanel shadingColor="true" visible={loading} delay={10} />
      <Toast
        visible={toastConfig.isVisible}
        message={toastConfig.message}
        type={toastConfig.type}
        position={"top"}
        width={"auto"}
      />
      <section className="login">
        <div className="container">
          <div className="login__flex">
            <div className="login__item login__item--img" />
            <div className="login__item login__item--form">
              <div className="branding">
                <div className="branding__logo">
                  <img
                    src={logomain}
                    alt="Logo | Welcome To UPA"
                    className="branding__logo__img"
                  />
                </div>
                <div className="branding__info branding__info--center">
                  <h1 className="title title--h1">OTP Verification</h1>
                  <p className="text">Type the OTP sent to the given Email</p>
                </div>
              </div>
              <div className="login__form">
                <form
                  onSubmit={(e) => {
                    e.preventDefault();
                    OnSubmit();
                  }}
                >
                  <div className="form__group">
                    <div className="form__group__flex form__group--otp">
                      <OtpInput
                        value={otp}
                        onChange={(e) => {
                          setvalidation("");
                          setOtp(e);
                        }}
                        numInputs={6}
                        inputType="number"
                        renderSeparator={
                          <span style={{ width: "10px" }}></span>
                        }
                        renderInput={(props) => (
                          <input
                            {...props}
                            style={{
                              fontSize: "1.75rem",
                              fontWeight: 700,
                              width: "68px",
                              height: "65px",
                              border: validation ? "2px solid red" : "none",
                              background: "#e6e6e6",
                              borderBottom: "5px solid #0475d7",
                              borderRadius: 0,
                              textAlign: "center",
                            }}
                          />
                        )}
                      />
                    </div>
                  </div>
                  {validation && (
                    <p
                      className="field-error"
                      style={{ marginTop: "-4px", marginLeft: "20px" }}
                    >
                      {validation}
                    </p>
                  )}
                  <div style={{ marginTop: "40px" }} className="form__group">
                    <p className="para para--center">
                      Didn’t receive OTP?{" "}
                      <Link className="link" href="#">
                        Resend OTP
                      </Link>
                    </p>
                  </div>
                  <div className="form__group">
                    <button
                      onClick={() => {
                        OnSubmit();
                      }}
                      className="btn btn--primary btn--full uppercase"
                    >
                      Submit
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};
